/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Token_Icon_Current_Price_LabelInputs */

const en_components_token_icon_current_price_label = /** @type {(inputs: Components_Token_Icon_Current_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current price`)
};

const de_components_token_icon_current_price_label = /** @type {(inputs: Components_Token_Icon_Current_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktueller Preis`)
};

const pt_br2_components_token_icon_current_price_label = /** @type {(inputs: Components_Token_Icon_Current_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço atual`)
};

const tr_components_token_icon_current_price_label = /** @type {(inputs: Components_Token_Icon_Current_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güncel fiyat`)
};

const zh_cn2_components_token_icon_current_price_label = /** @type {(inputs: Components_Token_Icon_Current_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前价格`)
};

const zh_hk2_components_token_icon_current_price_label = /** @type {(inputs: Components_Token_Icon_Current_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現價`)
};

const ko_kr2_components_token_icon_current_price_label = /** @type {(inputs: Components_Token_Icon_Current_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 가격`)
};

const ru_ru2_components_token_icon_current_price_label = /** @type {(inputs: Components_Token_Icon_Current_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущая цена`)
};

const es_419_components_token_icon_current_price_label = /** @type {(inputs: Components_Token_Icon_Current_Price_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio actual`)
};

/**
* | output |
* | --- |
* | "Current price" |
*
* @param {Components_Token_Icon_Current_Price_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_token_icon_current_price_label = /** @type {((inputs?: Components_Token_Icon_Current_Price_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Token_Icon_Current_Price_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_token_icon_current_price_label(inputs)
	if (locale === "de") return de_components_token_icon_current_price_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_token_icon_current_price_label(inputs)
	if (locale === "tr") return tr_components_token_icon_current_price_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_token_icon_current_price_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_token_icon_current_price_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_token_icon_current_price_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_token_icon_current_price_label(inputs)
	return es_419_components_token_icon_current_price_label(inputs)
});